import {Component, OnInit} from '@angular/core';
import {EmploymentStateDBService} from '../../../../@db/employment-state-db.service';
import {LoanApplicationService} from '../../loan-application.service';
import {EmploymentStatus} from '../../../../@models/employment-status.model';
import {CountrySelectService} from '../../../../@modules/country-select/country-select.service';
import {OfwStatusSelectService} from 'src/app/@modules/ofw-status-select/ofw-status-select.service';
import {OfwStatus} from 'src/app/@modules/ofw-status-select/ofw-status.model';

@Component({
  selector: 'bb-employment-state',
  templateUrl: './employment-state.component.html',
  styleUrls: ['./employment-state.component.scss'],
})
export class EmploymentStateComponent implements OnInit {
  current_status = this.loan.form.get('current_status');
  employment_status = this.current_status.get('employment_status');
  employment_channel = this.loan.form.get('employment_info.employment_channel');
  employment_type = this.loan.form.get('employment_info.employment_type');
  looking = EmploymentStatus.KnownStatuses.looking;
  pre_employment = EmploymentStatus.KnownStatuses.pre_employment;
  done_requirements = EmploymentStatus.KnownStatuses.done_requirements;
  balik_manggagawa = EmploymentStatus.KnownStatuses.balik_manggagawa;
  working_flyback = EmploymentStatus.KnownStatuses.working_flyback;
  working = EmploymentStatus.KnownStatuses.working;
  job_title = this.loan.form.get('employment_info').get('job_title');
  destined_country = this.loan.form.get('employment_info').get('destined_country');
  statusMapping = {};

  constructor(public statuses: EmploymentStateDBService,
              public loan: LoanApplicationService,
              public country: CountrySelectService,
              public ofwStatus: OfwStatusSelectService) {
  }

  ngOnInit(): void {
    // Map OFW status to employment statuses to determine which options to display
    this.ofwStatus.list.subscribe(
      (statuses: OfwStatus[]) => {
        statuses.forEach((status) => {
          this.statusMapping[status.value] = status.employment_statuses[this.employment_type.value];
        });
      },
      (error: any) => {
        console.error(JSON.stringify(error));
      }
    );
  }

  isOptionAvailable(employmentState: any): boolean {
    const key = this.employment_type.value === 'land' 
      ? this.employment_channel.value 
      : Object.keys(this.statusMapping)[0];
      return this.statusMapping[key].includes(employmentState.alias);
  }
  
}
